import {Alert, CircularProgress, IconButton} from "@mui/material";
import * as React from "react";
import {Refresh} from "@mui/icons-material";


function PageLoading({error,onRefresh}){
    return <div style={{ minHeight: 40, height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }}>

        {error ? <div className={'w-full lg:w-6/12'}>
                <Alert
                    style={{width: "100%"}}
                    spacing={2}
                    severity={"error"}
                    action={<IconButton onClick={onRefresh}>
                        <Refresh/>
                    </IconButton>}
                >
                    {error}
                </Alert>
        </div> : <CircularProgress style={{ color: "green" }}/>}
    </div>
}

export default PageLoading;
